const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const ssoHost = publicConfig.external_address;

exports.Profile = {
  create: function createProfile (profileBody, callback, query) {
    const requestBody = profileBody;
    requestBody.grant_type = 'signup';

    const requestParams = {
      host: ssoHost,
      path: `/v1/profiles${query || ''}`,
      method: 'POST'
    };

    httpLib.request(requestParams, function (response) {
      callback(response);
    }, requestBody);
  },

  createSocial: function createProfile (profileBody, callback) {
    const requestBody = profileBody;
    requestBody.grant_type = 'social_signup';

    const requestParams = {
      host: ssoHost,
      path: '/v1/profiles',
      method: 'POST'
    };

    httpLib.request(requestParams, function (response) {
      callback(response);
    }, requestBody);
  },

  read: function readProfile (path, accessToken, callback) {
    const requestParams = {
      host: ssoHost,
      path,
      method: 'GET'
    };
    if (accessToken) {
      requestParams.headers = {
        Authorization: 'Bearer ' + accessToken
      };
    }
    httpLib.request(requestParams, function (response) {
      callback(response);
    }, null);
  },

  update: function updateProfile (path, accessToken, profileBody, callback) {
    const requestParams = {
      host: ssoHost,
      path: '/v1/profiles/' + path,
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, function (response) {
      callback(response);
    }, profileBody);
  },

  // pass in creation source as query to filter by credit type
  readCredits: function readProfileCredits (ssoId, accessToken, callback, query = '') {
    const requestParams = {
      host: ssoHost,
      path: `/v1/profiles/${ssoId}/credit${query}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    httpLib.request(requestParams, function (response) {
      callback(response);
    }, null);
  }
};
